module.exports = __webpack_public_path__ + "static/media/captainsChallenge.5add9f8a.svg";